/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Machines_Status_OfflineInputs */

const vi_tea_machines_status_offline = /** @type {(inputs: Tea_Machines_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mất kết nối`)
};

/**

* @param {Tea_Machines_Status_OfflineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_status_offline = /** @type {((inputs?: Tea_Machines_Status_OfflineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_Status_OfflineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_status_offline(inputs)
});